export default "__VITE_ASSET__DRK92tJk__"